import(/* webpackMode: "eager" */ "/builder/src/app/page.tsx")